module.exports = [
	{
		"id": "30085001",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30085001/640/30085001.jpg",
		"headline": "GROHE Red Mono",
		"subheadline": "Starter kit taglia M",
		"textblock_1st_text": "30085001",
		"textblock_2nd_text": "Set rubinetto per cucina GROHE RED Mono (bocca a C) con filtro e boiler taglia M per acqua bollente istantanea. Finitura cromo. Efficienza energetica in classe A e funzioni di sicurezza",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.it/it_it/product/30085001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.it/it_it/our-service/showrooms-installer.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30083DC1",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30083DC1/640/30083DC1.jpg",
		"headline": "GROHE Red Duo",
		"subheadline": "Starter kit taglia M",
		"textblock_1st_text": "30083DC1",
		"textblock_2nd_text": "Set rubinetto per cucina GROHE RED Duo (bocca a C) con filtro e boiler taglia M per acqua bollente istantanea. Look acciaio inossidabile opaco. Efficienza energetica in classe A e funzioni di sicurezza",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.it/it_it/product/30083DC1",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.it/it_it/our-service/showrooms-installer.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30083001",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30083001/640/30083001.jpg",
		"headline": "GROHE Red Duo",
		"subheadline": "Starter kit taglia M",
		"textblock_1st_text": "30083001",
		"textblock_2nd_text": "Set rubinetto per cucina GROHE RED Duo (bocca a C) con filtro e boiler taglia M per acqua bollente istantanea. Finitura cromo. Efficienza energetica in classe A e funzioni di sicurezza",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.it/it_it/product/30083001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.it/it_it/our-service/showrooms-installer.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "31455DC0",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31455DC0/640/31455DC0.jpg",
		"headline": "GROHE Blue Home",
		"subheadline": "Starter kit",
		"textblock_1st_text": "31455DC0",
		"textblock_2nd_text": "Starter kit GROHE Blue Home Duo: miscelatore monocomando per la cucina per acqua filtrata, refrigerata e frizzante. Include unità refrigerante, filtro e bombola CO2 per l’aggiunta di anidride carbonica. Bocca alta a C, look in acciaio inossidabile.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.it/it_it/product/31455DC0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.it/it_it/our-service/showrooms-installer.html#productline=G427_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "31455000",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31455000/640/31455000.jpg",
		"headline": "GROHE Blue Home",
		"subheadline": "Starter kit",
		"textblock_1st_text": "31455000",
		"textblock_2nd_text": "Starter kit GROHE Blue Home Duo: miscelatore monocomando per la cucina per acqua filtrata, refrigerata e frizzante. Include unità refrigerante, filtro e bombola CO2 per l’aggiunta di anidride carbonica. Bocca alta a C, finitura cromata.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.it/it_it/product/31455000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.it/it_it/our-service/showrooms-installer.html#productline=G427_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "31454DC0",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31454DC0/640/31454DC0.jpg",
		"headline": "GROHE Blue Home",
		"subheadline": "Starter kit",
		"textblock_1st_text": "31454DC0",
		"textblock_2nd_text": "Starter kit GROHE Blue Home Duo: miscelatore monocomando per la cucina per acqua filtrata, refrigerata e frizzante. Include unità refrigerante, filtro e bombola CO2 per l’aggiunta di anidride carbonica. Bocca alta a L, look in acciaio inossidabile.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.it/it_it/product/31454DC0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.it/it_it/our-service/showrooms-installer.html#productline=G427_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "31454000",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31454000/640/31454000.jpg",
		"headline": "GROHE Blue Home",
		"subheadline": "Starter kit",
		"textblock_1st_text": "31454000",
		"textblock_2nd_text": "Starter kit GROHE Blue Home Duo: miscelatore monocomando per la cucina per acqua filtrata, refrigerata e frizzante. Include unità refrigerante, filtro e bombola CO2 per l’aggiunta di anidride carbonica. Bocca alta a L, finitura cromata.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.it/it_it/product/31454000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.it/it_it/our-service/showrooms-installer.html#productline=G427_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30327DC1",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30327DC1/640/30327DC1.jpg",
		"headline": "GROHE Red Duo",
		"subheadline": "Starter kit taglia M",
		"textblock_1st_text": "30327DC1",
		"textblock_2nd_text": "Set rubinetto per cucina GROHE RED Duo (bocca a L) con filtro e boiler taglia M per acqua bollente istantanea. Look acciaio inossidabile opaco. Efficienza energetica in classe A e funzioni di sicurezza",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.it/it_it/product/30327DC1",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.it/it_it/our-service/showrooms-installer.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30327001",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30327001/640/30327001.jpg",
		"headline": "GROHE Red Duo",
		"subheadline": "Starter kit taglia M",
		"textblock_1st_text": "30327001",
		"textblock_2nd_text": "Set rubinetto per cucina GROHE RED Duo (bocca a L) con filtro e boiler taglia M per acqua bollente istantanea. Finitura cromo. Efficienza energetica in classe A e funzioni di sicurezza",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.it/it_it/product/30327001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.it/it_it/our-service/showrooms-installer.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "31498000",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31498000/640/31498000.jpg",
		"headline": "GROHE Blue Home",
		"subheadline": "Starter kit",
		"textblock_1st_text": "31498000",
		"textblock_2nd_text": "Starter kit GROHE Blue Home Mono: rubinetto a colonna per acqua filtrata, refrigerata e frizzante. Include unità refrigerante, filtro e bombola CO2 per l’aggiunta di anidride carbonica. Bocca alta a C, finitura cromata.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.it/it_it/product/31498000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.it/it_it/our-service/showrooms-installer.html#productline=G427_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "31456DC0",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31456DC0/640/31456DC0.jpg",
		"headline": "GROHE Blue Home",
		"subheadline": "Starter kit",
		"textblock_1st_text": "31456DC0",
		"textblock_2nd_text": "Starter kit GROHE Blue Home Duo: miscelatore monocomando per la cucina per acqua filtrata, refrigerata e frizzante. Include unità refrigerante, filtro e bombola CO2 per l’aggiunta di anidride carbonica. Bocca alta a U, look in acciaio inossidabile.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.it/it_it/product/31456DC0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.it/it_it/our-service/showrooms-installer.html#productline=G427_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "31456000",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31456000/640/31456000.jpg",
		"headline": "GROHE Blue Home",
		"subheadline": "Starter kit",
		"textblock_1st_text": "31456000",
		"textblock_2nd_text": "Starter kit GROHE Blue Home Duo: miscelatore monocomando per la cucina per acqua filtrata, refrigerata e frizzante. Include unità refrigerante, filtro e bombola CO2 per l’aggiunta di anidride carbonica. Bocca alta a U, finitura cromata.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.it/it_it/product/31456000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.it/it_it/our-service/showrooms-installer.html#productline=G427_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30325DC1",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30325DC1/640/30325DC1.jpg",
		"headline": "GROHE Red Duo",
		"subheadline": "Starter kit taglia L",
		"textblock_1st_text": "30325DC1",
		"textblock_2nd_text": "Set rubinetto per cucina GROHE RED Duo (bocca a L) con filtro e boiler taglia L per acqua bollente istantanea. Finitura acciaio inossidabile opaco. Efficienza energetica in classe A e funzioni di sicurezza",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.it/it_it/product/30325DC1",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.it/it_it/our-service/showrooms-installer.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30325001",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30325001/640/30325001.jpg",
		"headline": "GROHE Red Duo",
		"subheadline": "Starter kit taglia L",
		"textblock_1st_text": "30325001",
		"textblock_2nd_text": "Set rubinetto per cucina GROHE RED Duo (bocca a L) con filtro e boiler taglia L per acqua bollente istantanea. Finitura cromo. Efficienza energetica in classe A e funzioni di sicurezza",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.it/it_it/product/30325001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.it/it_it/our-service/showrooms-installer.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30080001",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30080001/640/30080001.jpg",
		"headline": "GROHE Red Mono",
		"subheadline": "Starte kit taglia L",
		"textblock_1st_text": "30080001",
		"textblock_2nd_text": "Set rubinetto per cucina GROHE RED Mono (bocca a C) con filtro e boiler taglia L per acqua bollente istantanea. Finitura cromo. Efficienza energetica in classe A e funzioni di sicurezza",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.it/it_it/product/30080001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.it/it_it/our-service/showrooms-installer.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30079DC1",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30079DC1/640/30079DC1.jpg",
		"headline": "GROHE Red Duo",
		"subheadline": "Starter kit taglia L",
		"textblock_1st_text": "30079DC1",
		"textblock_2nd_text": "Set rubinetto per cucina GROHE RED Duo (bocca a C) con filtro e boiler taglia L per acqua bollente istantanea. Look acciaio inossidabile opaco. Efficienza energetica in classe A e funzioni di sicurezza",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.it/it_it/product/30079DC1",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.it/it_it/our-service/showrooms-installer.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30079001",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30079001/640/30079001.jpg",
		"headline": "GROHE Red Duo",
		"subheadline": "Starter kit taglia L",
		"textblock_1st_text": "30079001",
		"textblock_2nd_text": "Rubinetto per la cucina GROHE RED Duo (bocca a C) con set filtrante e boiler taglia L per acqua bollente istantanea. Finitura cromo Efficienza energetica in classe A e funzioni di sicurezza",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.it/it_it/product/30079001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.it/it_it/our-service/showrooms-installer.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "31498DC0",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31498DC0/640/31498DC0.jpg",
		"headline": "GROHE Blue Home",
		"subheadline": "Starter kit",
		"textblock_1st_text": "31498DC0",
		"textblock_2nd_text": "Starter kit GROHE Blue Home Mono: rubinetto a colonna per acqua filtrata, refrigerata e frizzante. Include unità refrigerante, filtro e bombola CO2 per l’aggiunta di anidride carbonica. Bocca alta a C, look in acciaio inossidabile.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.it/it_it/product/31498DC0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.it/it_it/our-service/showrooms-installer.html#productline=G427_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30339001",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30339001/640/30339001.jpg",
		"headline": "GROHE Red Mono",
		"subheadline": "Starter kit taglia M",
		"textblock_1st_text": "30339001",
		"textblock_2nd_text": "Set rubinetto per cucina GROHE RED Mono (bocca a L) con filtro e boiler taglia M per acqua bollente istantanea. Finitura cromo. Efficienza energetica in classe A e funzioni di sicurezza",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.it/it_it/product/30339001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.it/it_it/our-service/showrooms-installer.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "40841001",
		"image": "//cdn.cloud.grohe.com/prod/40/40/40841001/640/40841001.jpg",
		"headline": "GROHE Red",
		"subheadline": "Valvola di miscelazione",
		"textblock_1st_text": "40841001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.it/it_it/product/40841001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.it/it_it/our-service/showrooms-installer.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	}
];


//////////////////
// WEBPACK FOOTER
// ./src/data/water_products_it_it.json
// module id = 884
// module chunks = 0